module.exports = __webpack_public_path__ + "img/72.27130a55.jpg";